const t = {
  name: "StarFill",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.6671 8.09731L12.0004 0.763916L8.3337 8.09731L1.03711 9.3134L6.40808 15.2812L4.64079 22.8652L12.005 19.1196L19.5255 22.8671L17.6009 15.272L22.9637 9.3134L15.6671 8.09731Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as StarFill
};
